import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTheme } from '@mui/material';
import { getLogo } from '../helpers/Generichelper';
import { getChannelSettingByKey } from '../../routes/generic/Helpers/GenericIndexHelper';
import { useStylesFooterLogo } from '../styles/FooterStyles';

// The wrapper and link use the same Tailwind classes as the tertiary logo column in FooterLayout
// rather than a style object, because the two blocks are meant to render identically and having
// them laid out by two different mechanisms is how they drifted apart. `flex` on the Link keeps the
// logo off the text baseline, which would otherwise add descender space under it.
function FooterLogo() {
	const theme = useTheme();
	const secondaryLogoTextColor = getChannelSettingByKey('Footer-Logo-Text-Color');
	const classes = useStylesFooterLogo(theme, secondaryLogoTextColor);
	const agentDetails = useSelector(({ fuse }) => fuse?.form?.referenceTokenDetails?.agentDetails);
	const footerLogo =
		agentDetails?.agentLogoType === 2 && agentDetails?.agentLogoBlobUrl
			? agentDetails?.agentLogoBlobUrl
			: getLogo()?.secondaryLogo;
	const secondaryLogoText = getChannelSettingByKey('SECONDARY-LOGO-TEXT');

	return (
		<div className="flex flex-col items-center">
			<Link to="/" className="flex">
				{footerLogo && <img style={classes.logo} src={footerLogo} alt="" />}
			</Link>
			{secondaryLogoText && <span style={classes.logoText}>{secondaryLogoText}</span>}
		</div>
	);
}

export default FooterLogo;
